import React, { Component } from 'react';
import { connect } from 'react-redux';
import { api, categoryUploadDir } from '../../../config';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './HomeItem.css';
import bt from '../../../components/commonStyle.css';

export class HomeItem extends Component {
    render() {
        const { categoryName, categoryImage } = this.props;

        return (
            <div>
                <div className={cx(s.sliderBox, 'sliderBoxDark')}>
                    <img
                        style={{ maxWidth: 'auto', height: 'auto' }}
                        src={api?.apiEndpoint + categoryUploadDir + categoryImage}
                    />
                </div>
                <div className={s.sliderBottom}>
                    <div className={cx(s.fontNormal, 'textWhite')} >{categoryName}</div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default withStyles(s, bt)(connect(mapStateToProps, mapDispatchToProps)(HomeItem)) 
